var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMarkSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-check 1",
    clipPath: "url(#clip0_1271_13356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 9C0.5 4.02891 4.52891 0 9.5 0C14.4711 0 18.5 4.02891 18.5 9C18.5 13.9711 14.4711 18 9.5 18C4.52891 18 0.5 13.9711 0.5 9ZM13.5711 7.44609C13.9543 7.06289 13.9543 6.43711 13.5711 6.05391C13.1879 5.6707 12.5621 5.6707 12.1789 6.05391L8.375 9.85781L6.82109 8.30391C6.43789 7.9207 5.81211 7.9207 5.42891 8.30391C5.0457 8.68711 5.0457 9.31289 5.42891 9.69609L7.67891 11.9461C8.06211 12.3293 8.68789 12.3293 9.07109 11.9461L13.5711 7.44609Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_13356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkSvg);
export default __webpack_public_path__ + "static/media/CheckMarkSvg.45e07a606853fcba0ef149b0dc4b2f7a.svg";
export { ForwardRef as ReactComponent };